import { render } from "./basic_input.vue?vue&type=template&id=634c3250"
import script from "./basic_input.vue?vue&type=script&lang=js"
export * from "./basic_input.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/components/input/basic_input.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "634c3250"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('634c3250', __exports__)) {
    api.reload('634c3250', __exports__)
  }
  
  module.hot.accept("./basic_input.vue?vue&type=template&id=634c3250", () => {
    api.rerender('634c3250', render)
  })

}


export default __exports__